// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__Lkr90","wrapper":"Card_wrapper__oqFJK","left":"Card_left__2imo_","button":"Card_button__2U32q","priceFooter":"Card_priceFooter__H6YRz"};